import { types } from './i18n.ts';

export default {
  component: () => import('./page.vue'),
  path: '/message/:type',
  name: 'message',
  meta: {
    title: '消息中心',
    titleKey: 'type',
    titleMaps: types,
    auth: true,
  },
};
